<script setup lang="ts">
interface Props {
  text: string
  iconClass?: string
  colSpanFull?: boolean
}

withDefaults(defineProps<Props>(), {
  iconClass: undefined,
  colSpanFull: true,
})
</script>

<template>
  <div :class="[{ 'col-span-full': colSpanFull }, 'mb-2']">
    <TitleComponent
      :text
      no-caps
      type="subtitle"
      :icon-class
    />
  </div>
</template>
